import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';

//Global scss
import './scss/App.scss';
//Google analytics
import GoogleAnalytics from './components/google-analytics/GoogleAnalytics';
import { useSelector } from 'react-redux';
import { selectPageData, selectGlobalsSettings, selectCanScroll } from './redux/globals/globals.selectors';

import GamePage from './pages/GamePage';
import Statistics from './pages/screens/Stats.screen';

const App = (props) => {
	const pageData = useSelector(selectPageData);
	const { lang } = useSelector(selectGlobalsSettings);

	return (
		<>
			<Helmet>
				<html lang={lang} />
				<title>Pocket Rockets Game</title>
				<meta name="title" content="Pocket Rockets Game" />
				<meta
					name="description"
					content="The year is 2553, White Rabbit is helping humanity colonize a habitable planetary system in another dimension!"
				/>
			</Helmet>

			<div className={`wrapper`}>
				<Switch>
					<Route exact path="/stats">
						<Statistics />
					</Route>

					<Route>
						<GamePage />
					</Route>
				</Switch>
			</div>
			<GoogleAnalytics />
		</>
	);
};

export default App;
